import React from 'react';
import useTargetStorage from "@/hooks/useTargetStorage"
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Section from 'components/layout/section';
import SectionHeader from 'components/layout/sectionHeader';
import SectionHeaderTitle from 'components/layout/sectionHeaderTitle';
import PageTitle from 'features/navigation/pageTitle';
import EditTransactionForm from 'components/transactions/EditTransactionForm';
import { FormStatus } from 'types';
import useTransactions from '@/hooks/useTransactions';
import useStorages from '@/hooks/useStorages';
import { paramGuardStorage } from '@/utils/paramGuard';
import RightSidebarTransaction from '@/components/sidebar/right/RightSidebarTransaction';

const EditTransactionPage: React.FC = () => {
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { targetStorageDocId: storageId } = useTargetStorage();
  const { transactionId } = useParams<{ transactionId: string }>();

  const { 
    transaction, 
    transactionStatus 
  } = useTransactions({ storageId, transactionId });
  
  const { 
    storage,
    storageStatus,
    isTransactionsEnabled
  } = useStorages({ storageId });

  // Check params and declare safe ones to use in JSX
  if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
    return <></>;
  }
  const safeStorageId = storageId!;
  const safeTransactionId = transactionId!;

  // Redirect if transactions are disabled for this storage
  if (!isTransactionsEnabled()) {
    navigate(`/storage`);
    return <></>;
  }

  // Handle transaction loading and error states
  if (transactionStatus === FormStatus.LOADING) {
    return (
      <>
        <PageTitle title={t('titleEditTransaction')} />
        <Section>
          <div>Loading...</div>
        </Section>
      </>
    );
  }

  if (transactionStatus === FormStatus.ERROR || !transaction) {
    navigate(`/storage/transactions`);
    return <></>;
  }

  return (
    <>
      <PageTitle title={t('titleEditTransaction')} />
      <Section>
        <EditTransactionForm 
          storageId={safeStorageId} 
          transactionId={safeTransactionId}
          transaction={transaction as any}
        />
      </Section>
      <RightSidebarTransaction storageId={safeStorageId} transactionId={safeTransactionId} />
    </>
  );
};

export default EditTransactionPage;
